import React from "react";
import { useNavigate } from "react-router-dom";
import { resolveWidgetColor } from "./widgetColors";

const HeroWidget = ({ widget, resolveSlugPath }) => {
  const navigate = useNavigate();
  const props = widget.props || {};
  const {
    title,
    subtitle,
    background_color: backgroundColor,
    background_image_url: backgroundImageUrl,
    text_color: textColor,
    cta_label: ctaLabel,
    cta_target_slug: ctaTargetSlug,
    cta_target_path: ctaTargetPath,
  } = props;

  const palette = resolveWidgetColor(backgroundColor);
  const textColorClass = textColor === "dark" ? "text-gray-900" : "text-white";
  const bgClass = backgroundImageUrl ? "" : palette.solid;

  const style = backgroundImageUrl
    ? { backgroundImage: `url(${backgroundImageUrl})`, backgroundSize: "cover", backgroundPosition: "center" }
    : undefined;

  const handleCta = () => {
    if (ctaTargetSlug) navigate(resolveSlugPath(ctaTargetSlug));
    else if (ctaTargetPath) navigate(ctaTargetPath);
  };

  return (
    <div className={`rounded-xl px-8 py-12 ${bgClass} ${textColorClass}`} style={style}>
      {title && <h2 className="text-3xl font-bold mb-2">{title}</h2>}
      {subtitle && <p className="text-lg opacity-90 max-w-2xl">{subtitle}</p>}
      {ctaLabel && (ctaTargetSlug || ctaTargetPath) && (
        <button
          type="button"
          onClick={handleCta}
          className="mt-6 rounded-md bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 hover:bg-gray-100 transition"
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
};

export default HeroWidget;
